var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7539_15558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4726 1.81934H10.0254V15.1821H17.4726V1.81934Z",
    fill: "#FF5A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5208 8.49956C10.5208 5.78465 11.7987 3.37507 13.7597 1.81819C12.3165 0.684916 10.496 0 8.51029 0C3.80622 0 0 3.80142 0 8.49956C0 13.1977 3.80622 16.9991 8.51029 16.9991C10.496 16.9991 12.3165 16.3142 13.7597 15.1809C11.796 13.6461 10.5208 11.2145 10.5208 8.49956Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5194 8.49956C27.5194 13.1977 23.7132 16.9991 19.0092 16.9991C17.0234 16.9991 15.2029 16.3142 13.7598 15.1809C15.7455 13.6213 16.9986 11.2145 16.9986 8.49956C16.9986 5.78465 15.7207 3.37507 13.7598 1.81819C15.2002 0.684916 17.0207 0 19.0064 0C23.7132 0 27.5194 3.82618 27.5194 8.49956Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7539_15558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5193,
    height: 16.9991,
    fill: "white"
  })))));
};
export { SvgMastercard as ReactComponent };